export const stringsKey = "IVRFlowWizardConfiguration";
export const englishStrings = {
	noWidgetConfiguredMessage: "No Widget(s) configured.",
	addWidgetTooltip: "Add Widget",
};
